import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

interface ReasonElement {
	title: String;
	value: String;
}

@Component({
	selector: 'app-confirm-with-reason-modal',
	templateUrl: './confirm-with-reason-modal.component.html'
})

export class ConfirmWithReasonModalComponent implements OnInit {
	@ViewChild('selectReason') selectReason!: MatSelect;

	@Input() htmlTitle: String;
	@Input() htmlMessage: String;
	@Input() reasonList: ReasonElement[];

	public reason: string = '';

	constructor(
		public activeModal: NgbActiveModal,
	) { }

	ngOnInit() {
		if (this.reasonList.length) {
			setTimeout(() => {
				this.selectReason.focus();
			});
		}
	}

	public closeModal(confirmed: boolean) {
		if (confirmed && this.reasonList.length && !this.reason) {
			return;
		}

		this.activeModal.close({
			confirmed,
			reason: this.reason,
		});
	}
}
